import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import React, {memo} from 'react';

const Help = (props: any) => {
    const {heading, helpdata, className, headingSx} = props;
    return (
        <Box className="help-main-box margin">
            <Typography className={`${className}`} sx={headingSx}>
                {heading}
            </Typography>
            <Box className="divder-wrapper perfect-blockchain-divider-wrapper">
                <hr className="divider-line divider-margin" />
            </Box>
            {helpdata?.map((data: any, index: any) => (
                <Box key={index + 1}>
                    <Typography className="blockchain-para">{data}</Typography>
                </Box>
            ))}
        </Box>
    );
};
export default memo(Help);
